export interface AppCoachDiagnosticsRootListFormRemove {
  id: string;
  user_id: string;
  organization_id: string;
  diagnostic_category_id: string;
  diagnostic_category: {
    id: string;
    content: {
      name: string;
      fields: any;
    }
  }
  user: {
    id: string;
    content: {
      name: string;
      surname: string;
    };
  }
  content: {
    date: string;
    fields: any;
  };
}

export class AppCoachDiagnosticsRootListFormRemove implements AppCoachDiagnosticsRootListFormRemove {
  id: string;
  user_id: string;
  organization_id: string;
  diagnostic_category_id: string;
  content: {
    date: string;
    fields: any;
  };
  diagnostic_category: {
    id: string;
    content: {
      name: string;
      fields: any;
    }
  }
  user: {
    id: string;
    content: {
      name: string;
      surname: string;
    };
  }

  constructor() {
    this.id = "";
    this.user_id = "";
    this.organization_id = "";
    this.diagnostic_category_id = "";
    this.content = {
      date: "",
      fields: [],
    };
    this.diagnostic_category = {
      id: "",
      content: {
        name: "",
        fields: [],
      }
    };
    this.user = {
      id: "",
      content: {
        name: "",
        surname: "",
      },
    };
  }
}